var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show == true
      ? _c("div", { staticClass: "gray" }, [
          _c("div", { staticClass: "dialog" }, [
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c("p", { staticClass: "title" }, [_vm._v("Upload Invoice")]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c("b-form-file", {
                  staticClass: "upload-box text-nowrap text-truncate",
                  attrs: {
                    size: "lg",
                    accept: "application/pdf",
                    placeholder: "Choose or Drop file here",
                    "drop-placeholder": "Drop file here"
                  },
                  on: {
                    input: function($event) {
                      return _vm.select()
                    }
                  },
                  model: {
                    value: _vm.uploadFile,
                    callback: function($$v) {
                      _vm.uploadFile = $$v
                    },
                    expression: "uploadFile"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "uploading-box",
                    class: { hidden: !_vm.loading }
                  },
                  [
                    _c("div", {
                      staticClass: "uploading-bar-green",
                      attrs: { id: "loading-progress" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          float: "left",
                          width: "100px",
                          "margin-bottom": "0px"
                        }
                      },
                      [_vm._v("Invoice ID")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoiceId,
                          expression: "invoiceId"
                        }
                      ],
                      staticStyle: { float: "left", width: "100px" },
                      domProps: { value: _vm.invoiceId },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.invoiceId = $event.target.value
                          },
                          function($event) {
                            return _vm.inputNumber($event, "invoiceId")
                          }
                        ]
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          float: "left",
                          width: "100px",
                          "margin-bottom": "0px"
                        }
                      },
                      [_vm._v("Amount")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.amount,
                          expression: "amount"
                        }
                      ],
                      staticStyle: { float: "left", width: "100px" },
                      domProps: { value: _vm.amount },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.amount = $event.target.value
                          },
                          function($event) {
                            return _vm.inputNumber($event, "amount")
                          }
                        ]
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "buttons",
                    attrs: { disabled: !_vm.ready },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v("Upload")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "buttons",
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b24e864", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b24e864","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/upload_invoice.vue
// module id = 842
// module chunks = 0